module.exports = __webpack_public_path__ + "json/market15-0.json?02e234c915d7d66ca36df46abe6e4745";


//////////////////
// WEBPACK FOOTER
// ./src/assets/packed/market/market15-0.json
// module id = 1258
// module chunks = 3